import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Button, Spinner } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import { debounce, map, range } from "lodash"

import ToolkitProvider from "react-bootstrap-table2-toolkit"

//actions

import "../../assets/scss/datatables.scss"

import MyPagination from "components/Common/MyPagination"
import DeleteModal from "components/Common/DeleteModal"
import { AvField, AvForm } from "availity-reactstrap-validation"
import moment from "moment"
import YoutubeShortModal from "./Crud/Modal"
import { deleteYoutubeShortVideo, getYoutubeShortVideos } from "store/actions"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import YoutubePlayer from "components/YoutubePlayer"
import { useRole, ROLE_TYPES } from "hooks/useRole"

const YoutubeShortsVideos = () => {
  const { isRole, isAnyRole, canManageDelete } = useRole()
  const dispatch = useDispatch()
  const history = useHistory()
  const [page, setPage] = useState(1)
  const [youtubeShortModal, setYoutubeShortModal] = useState({
    status: false,
    data: {},
  })
  const [searchText, setSearchText] = useState("")
  const [totalItemLimit, setTotalItemLimit] = useState(() => {
    return parseInt(localStorage.getItem("shortLimit")) || 10
  })
  const { loading, youtubeShortVideos } = useSelector(state => ({
    loading: state.YoutubeShortVideo.loading,
    youtubeShortVideos: state?.YoutubeShortVideo?.shorts,
  }))

  const totalPages = Math.ceil(youtubeShortVideos?.total / totalItemLimit)
  const pages = range(1, totalPages + 1)

  useEffect(() => {
    dispatch(getYoutubeShortVideos(page, totalItemLimit, searchText))
  }, [dispatch, page, totalItemLimit, searchText])

  const updatedLocation = {
    ...location,
    state: {
      ...location.state,
      page: 1,
    },
  }

  const [isOpen, setIsOpen] = useState({ status: false, id: "" })

  const handleDelete = id => {
    setIsOpen({ status: true, id: id })
  }

  const handleDeleteEvent = () => {
    setIsOpen({ ...isOpen, status: false })
    dispatch(deleteYoutubeShortVideo(isOpen?.id))
  }

  const columns = [
    {
      dataField: "no",
      text: "#",
      sort: true,
    },
    {
      dataField: "createdAt",
      text: "Created At",
    },
    {
      dataField: "title",
      text: "Title",
      sort: true,
    },
    {
      dataField: "video_id",
      text: "Video Id",
      sort: true,
    },

    {
      dataField: "action",
      text: "Action",
    },
  ]

  const handleColumns = () => {
    if (isRole(ROLE_TYPES.SALES_MANAGER)) {
      return columns?.filter(i => i.dataField !== "action")
    } else return columns
  }

  const tableData = map(youtubeShortVideos?.shorts, (item, index) => ({
    ...item,
    no: <span>{index + 1 + (page - 1) * totalItemLimit}</span>,
    title: (
      <div style={{ whiteSpace: "break-spaces" }}>
        {item?.title
          ? `${item.title.slice(0, 170)}${item.title.length > 170 ? "..." : ""}`
          : "---"}
      </div>
    ),
    video_id: (
      // <div style={{ whiteSpace: "break-spaces" }}>
      //   {item?.video_id?.slice(0, 180)}
      //   {item?.video_id?.length > 180 ? "..." : ""}
      // </div>

      <div
        className="youtube-short-player-container"
        style={{
          width: "150px",
          height: "250px",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <YoutubePlayer videoId={item?.video_id} />
      </div>
    ),
    createdAt: moment(item.createdAt).format("DD/MM/YYYY - h:mm a"),
    action: (
      <div>
        <Button
          id={`edit${index}`}
          type="button"
          title="Edit Youtube Short Video"
          color="white"
          className="ms-1 btn"
          onClick={() => setYoutubeShortModal({ status: true, data: item })}
        >
          <i
            className="bx bx-edit-alt "
            style={{ color: "#ffa500", fontSize: "22px" }}
          />
        </Button>
        {canManageDelete() ? (
          <>
            <Button
              id={`Delete${index}`}
              type="button"
              color="white"
              title="Delete Youtube Short Video"
              className="ms-1 btn "
              onClick={() => {
                handleDelete(item._id)
              }}
            >
              <i
                className="bx bx-trash"
                style={{
                  color: "red",
                  fontSize: "1.3rem",
                }}
              />
            </Button>
          </>
        ) : (
          ""
        )}
      </div>
    ),
  }))

  const debounceClientSearch = debounce(value => {
    setSearchText(value)
    history.push(updatedLocation)
  }, 600)

  const handlePageLimit = e => {
    if (e.target.value >= 1) {
      setTotalItemLimit(parseInt(e.target.value))
      localStorage.setItem("shortLimit", e.target.value)
    }
  }

  return (
    <React.Fragment>
      <Row>
        <DeleteModal
          show={isOpen?.status}
          onCloseClick={() => setIsOpen({ ...isOpen, status: false })}
          onDeleteClick={handleDeleteEvent}
        />
        <YoutubeShortModal
          onCloseClick={() => setYoutubeShortModal({ status: false, data: {} })}
          show={youtubeShortModal?.status}
          updateData={youtubeShortModal?.data}
        />
        <Col className="col-12">
          <Card>
            <CardBody>
              <ToolkitProvider
                keyField="_id"
                key={"id"}
                columns={handleColumns()}
                data={tableData}
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <div className="d-flex align-items-center justify-content-between p-1">
                      {/* <div className="d-flex w-100"> */}
                      <div className="d-flex">
                        <div className="">
                          <div className="search-box mb-2 d-inline-block w-100">
                            <div className="position-relative mx-0">
                              <AvForm>
                                <AvField
                                  name="searchText"
                                  placeholder="Search"
                                  type="text"
                                  value={searchText}
                                  onChange={e =>
                                    debounceClientSearch(e.target.value)
                                  }
                                />
                              </AvForm>
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>{" "}
                        </div>
                        <div>
                          <AvForm className="form-horizontal mx-2 mb-3 d-flex align-items-center w-75">
                            <div className="mx-1">
                              <span className="">
                                Show
                                <i className="fas fa-sort-numeric-down-alt mx-1"></i>
                              </span>
                            </div>
                            <div className="" style={{ width: "50px" }}>
                              <AvField
                                name="pageLimit"
                                className="form-control"
                                value={totalItemLimit}
                                onChange={e => handlePageLimit(e)}
                                type="text"
                                required
                              />
                            </div>
                          </AvForm>
                        </div>
                      </div>
                      {/* <div className="w-25">
                          <Select
                            onInputChange={handleEntersClients}
                            value={client}
                            placeholder={client}
                            onChange={handlerClientFinalValue}
                            options={testimonialOptions}
                            classNamePrefix="select2-selection"
                            isLoading={loading}
                          />
                        </div> */}

                      {/* </div> */}
                      <Button
                        type="button"
                        color="warning"
                        className="btn-rounded  mb-2 me-2 "
                        onClick={() => setYoutubeShortModal({ status: true })}
                      >
                        <i className="mdi mdi-plus me-1" />
                        New Video
                      </Button>
                    </div>

                    {loading ? (
                      <Spinner color="secondary" className="d-block m-auto" />
                    ) : (
                      <>
                        {youtubeShortVideos?.total >= 1 ? (
                          <>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField={"id"}
                                    key={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    // selectRow={selectRow}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    // onTableChange={handleTableChange}
                                    // {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <MyPagination
                              totalPages={pages}
                              page={page}
                              setPage={setPage}
                            />
                          </>
                        ) : (
                          <p className="my-4 mx-3 ">
                            No Youtube Shorts Videos!
                          </p>
                        )}
                      </>
                    )}
                  </React.Fragment>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default YoutubeShortsVideos
